(function () {
  const COD_API = '/apps/cod/create';
  const PHONE_ERROR =
    'رقم هاتف تونسي غير صحيح. استعمل 8 أرقام (مثال: 22 222 222).';

  const FIELD_MESSAGES = {
    name: 'أدخل اسمك.',
    phone: PHONE_ERROR,
    ville: 'اختر ولايتك.',
    address: 'أدخل عنوانك (5 أحرف على الأقل).',
    email: 'أدخل بريدًا إلكترونيًا صحيحًا.',
  };

  const QTY_SELECTOR = '[data-input-quantity], input[name="quantity"]';

  function formatPhoneInput(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length > 8) digits = digits.slice(1);
    digits = digits.slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const text = Number.isInteger(amount) ? String(amount) : amount.toFixed(3);
    return `${text} DT · د.ت`;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]);
  }

  function normalizeTunisiaPhone(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length === 9) digits = digits.slice(1);
    if (digits.length !== 8 || !/^[234579]\d{7}$/.test(digits)) return null;
    return digits;
  }

  function formatTunisiaPhone(digits) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function splitName(fullName) {
    const parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return { prenom: '', nom: '' };
    if (parts.length === 1) return { prenom: parts[0], nom: parts[0] };
    return { prenom: parts[0], nom: parts.slice(1).join(' ') };
  }

  function getRoot(el) {
    return el.closest('[data-product-cod-checkout]');
  }

  function getForm(root) {
    return root?.querySelector('[data-quick-order-form]');
  }

  // The quantity block and the variant pickers live outside the COD block,
  // in the same product info column.
  function getScope(root) {
    return root.closest('.featured-product-content') || root.closest('section') || document;
  }

  function readFields(form) {
    const name = form.querySelector('[data-quick-order-field="name"]')?.value.trim() || '';
    const { prenom, nom } = splitName(name);
    return {
      name,
      prenom,
      nom,
      phone: form.querySelector('[data-quick-order-field="phone"]')?.value.trim() || '',
      email: form.querySelector('[data-quick-order-field="email"]')?.value.trim() || '',
      address: form.querySelector('[data-quick-order-field="address"]')?.value.trim() || '',
      ville: form.querySelector('[data-quick-order-field="ville"]')?.value.trim() || '',
    };
  }

  function showGlobalError(form, message) {
    const el = form.querySelector('[data-quick-order-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setFieldError(form, fieldKey, message) {
    const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
    const errEl = form.querySelector(`[data-field-error="${fieldKey}"]`);
    const input = form.querySelector(`[data-quick-order-field="${fieldKey}"]`);

    if (errEl) {
      errEl.textContent = message || '';
      errEl.hidden = !message;
    }
    if (wrap) wrap.classList.toggle('product-cod-form__field--error', Boolean(message));
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function validateField(fieldKey, fields) {
    switch (fieldKey) {
      case 'name':
        if (!fields.name || fields.name.length < 2) return FIELD_MESSAGES.name;
        return null;
      case 'phone':
        if (!normalizeTunisiaPhone(fields.phone)) return FIELD_MESSAGES.phone;
        return null;
      case 'ville':
        if (!fields.ville) return FIELD_MESSAGES.ville;
        return null;
      case 'address':
        if (!fields.address || fields.address.length < 5) return FIELD_MESSAGES.address;
        return null;
      case 'email':
        if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
          return FIELD_MESSAGES.email;
        }
        return null;
      default:
        return null;
    }
  }

  function validateAll(form) {
    const fields = readFields(form);
    let firstErrorKey = null;

    ['name', 'phone', 'ville', 'address', 'email'].forEach((key) => {
      const message = validateField(key, fields);
      setFieldError(form, key, message);
      if (message && !firstErrorKey) firstErrorKey = key;
    });

    if (firstErrorKey) {
      showGlobalError(form, 'يرجى تصحيح الحقول المحددة باللون الأحمر أعلاه.');
      const wrap = form.querySelector(`[data-cod-field="${firstErrorKey}"]`);
      wrap?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return false;
    }

    showGlobalError(form, '');
    return true;
  }

  function getQuantityInput(root) {
    return root.querySelector(QTY_SELECTOR) || getScope(root).querySelector(QTY_SELECTOR);
  }

  function getQuantity(root) {
    return Math.max(1, parseInt(getQuantityInput(root)?.value, 10) || 1);
  }

  function setQuantity(root, value) {
    const input = getQuantityInput(root);
    if (!input) return;
    input.value = String(value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getVariantId(root) {
    return root.querySelector('input[name="id"]')?.value;
  }

  function getVariants(root) {
    if (root._codVariants) return root._codVariants;
    let list = [];
    try {
      list = JSON.parse(root.querySelector('[data-cod-variants]')?.textContent || '[]');
    } catch (e) {
      console.warn('product-cod variants', e);
    }
    root._codVariants = new Map(list.map((v) => [String(v.id), v]));
    return root._codVariants;
  }

  // Items the customer added with "add another colour", in order.
  function getSavedLines(root) {
    if (!root._codLines) root._codLines = [];
    return root._codLines;
  }

  // What will be ordered: the saved items, plus the current selection
  // unless that exact variant is already saved.
  function getOrderLines(root) {
    const variants = getVariants(root);
    const toLine = (id, qty, savedIndex) => {
      const variant = variants.get(String(id));
      return {
        id: String(id),
        qty,
        savedIndex,
        title: variant?.title || '',
        price: Number(variant ? variant.price : root.dataset.variantPrice) || 0,
      };
    };

    const lines = getSavedLines(root).map((line, index) => toLine(line.id, line.qty, index));
    const currentId = getVariantId(root);
    if (currentId && !lines.some((line) => line.id === String(currentId))) {
      lines.push(toLine(currentId, getQuantity(root), -1));
    }
    return lines;
  }

  function shippingFee(root, subtotal) {
    const fee = Number(root.dataset.shippingFee) || 800;
    const min = Number(root.dataset.freeShippingMin) || 20000;
    return subtotal >= min ? 0 : fee;
  }

  function renderLines(root, lines) {
    const list = root.querySelector('[data-cod-lines]');
    if (!list) return;

    const hasSaved = getSavedLines(root).length > 0;
    list.hidden = !hasSaved;
    if (!hasSaved) {
      list.innerHTML = '';
      return;
    }

    list.innerHTML = lines
      .map((line) => {
        const action =
          line.savedIndex >= 0
            ? `<button type="button" class="product-cod-lines__remove" data-cod-remove-line="${line.savedIndex}" aria-label="حذف">×</button>`
            : `<span class="product-cod-lines__current">${escapeHtml(root.dataset.currentLabel || '')}</span>`;
        return (
          '<li class="product-cod-lines__item">' +
          `<span class="product-cod-lines__title">${escapeHtml(line.title)} × ${line.qty}</span>` +
          `<strong dir="ltr">${formatMoney(line.price * line.qty)}</strong>` +
          action +
          '</li>'
        );
      })
      .join('');
  }

  function updateSummary(root) {
    const lines = getOrderLines(root);
    const subtotal = lines.reduce((sum, line) => sum + line.price * line.qty, 0);
    const ship = shippingFee(root, subtotal);
    const total = subtotal + ship;

    const subEl = root.querySelector('[data-product-cod-subtotal]');
    const shipEl = root.querySelector('[data-product-cod-shipping]');
    const totalEl = root.querySelector('[data-product-cod-total]');
    const freeHint = root.querySelector('[data-cod-free-ship-hint]');

    if (subEl) subEl.textContent = formatMoney(subtotal);
    if (shipEl) shipEl.textContent = ship === 0 ? 'مجاني' : formatMoney(ship);
    if (totalEl) totalEl.textContent = formatMoney(total);

    if (freeHint) {
      const min = Number(root.dataset.freeShippingMin) || 20000;
      const missing = min - subtotal;
      freeHint.hidden = missing <= 0;
      if (missing > 0) {
        freeHint.textContent = (root.dataset.freeShipHint || '').replace('{amount}', formatMoney(missing));
      }
    }

    renderLines(root, lines);
  }

  function addCurrentLine(root) {
    const id = getVariantId(root);
    if (!id) return;
    const variant = getVariants(root).get(String(id));
    if (variant && variant.available === false) return;

    const lines = getSavedLines(root);
    const qty = getQuantity(root);
    const existing = lines.find((line) => line.id === String(id));
    if (existing) existing.qty += qty;
    else lines.push({ id: String(id), qty });

    setQuantity(root, 1);
    updateSummary(root);

    const hint = root.querySelector('[data-cod-lines-hint]');
    if (hint) hint.hidden = false;
    const pickers = getScope(root).querySelector('.product-variants-options-details, .color-swatches-box');
    pickers?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function removeLine(root, index) {
    const lines = getSavedLines(root);
    if (index < 0 || index >= lines.length) return;
    lines.splice(index, 1);
    updateSummary(root);
  }

  function buildCartPayload(lines) {
    const items = lines.map((line) => ({
      variant_id: Number(line.id),
      quantity: line.qty,
      price: line.price,
      line_price: line.price * line.qty,
    }));
    return {
      items,
      item_count: items.reduce((sum, item) => sum + item.quantity, 0),
      total_price: items.reduce((sum, item) => sum + item.line_price, 0),
    };
  }

  function clearCartInBackground() {
    const url = `${window.routes?.cart_url || '/cart'}/clear.js`;
    fetch(url, { method: 'POST', keepalive: true }).catch(() => {});
    if (typeof window.refreshHeaderCartCount === 'function') {
      window.refreshHeaderCartCount().catch(() => {});
    }
  }

  function redirectToConfirmation(root, orderName) {
    const base = root.dataset.confirmationUrl || '/pages/commande-confirmee';
    const params = new URLSearchParams();
    if (orderName) params.set('ref', orderName);
    if (root.dataset.productId) params.set('product_id', root.dataset.productId);
    window.location.href = `${base}?${params.toString()}`;
  }

  function setSubmitLoading(button, loading) {
    const label = button.querySelector('[data-product-cod-submit-text]');
    const loader = button.querySelector('.btn-loader');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (label) label.textContent = 'Création de votre commande…';
      loader?.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (label) label.textContent = 'Commander maintenant';
      loader?.classList.add('hidden');
    }
  }

  async function submitCodOrder(button) {
    const root = getRoot(button);
    const form = getForm(root);
    if (!root || !form) return;

    showGlobalError(form, '');
    if (!validateAll(form)) return;

    const fields = readFields(form);
    const phoneDigits = normalizeTunisiaPhone(fields.phone);
    fields.phone = formatTunisiaPhone(phoneDigits);
    if (!fields.email) fields.email = `client+${phoneDigits}@exceptiones.com`;

    const lines = getOrderLines(root);
    if (!lines.length) {
      showGlobalError(form, 'تعذر العثور على هذا الخيار من المنتج.');
      return;
    }

    setSubmitLoading(button, true);

    let redirecting = false;

    try {
      const cart = buildCartPayload(lines);

      const res = await fetch(COD_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ fields, cart }),
      });

      const payload = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(payload.error || 'تعذر إتمام الطلب حاليًا.');
      }

      redirecting = true;
      clearCartInBackground();
      redirectToConfirmation(root, payload.orderName);
    } catch (e) {
      console.error('[product-cod]', e);
      showGlobalError(
        form,
        e.message ||
          'الخدمة غير متوفرة حاليًا. حاول مجددًا أو تواصل معنا.',
      );
    } finally {
      if (!redirecting) setSubmitLoading(button, false);
    }
  }

  function bindFieldValidation(root) {
    const form = getForm(root);
    if (!form) return;

    form.querySelectorAll('[data-quick-order-field]').forEach((input) => {
      const fieldKey = input.dataset.quickOrderField;
      if (!fieldKey) return;

      const validateOne = () => {
        const fields = readFields(form);
        const message = validateField(fieldKey, fields);
        if (!message) {
          setFieldError(form, fieldKey, '');
          return;
        }
        if (fieldKey === 'email' && !fields.email) {
          setFieldError(form, fieldKey, '');
          return;
        }
        setFieldError(form, fieldKey, message);
      };

      input.addEventListener('blur', validateOne);
      input.addEventListener('input', () => {
        const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
        if (wrap?.classList.contains('product-cod-form__field--error')) {
          validateOne();
        }
      });
      input.addEventListener('change', validateOne);
    });
  }

  function bindPhoneInput(root) {
    const phone = root.querySelector('[data-quick-order-field="phone"]');
    if (!phone) return;

    const formatField = () => {
      const formatted = formatPhoneInput(phone.value);
      if (formatted !== phone.value) {
        phone.value = formatted;
        phone.setSelectionRange(formatted.length, formatted.length);
      }
    };

    phone.addEventListener('input', formatField);
    phone.addEventListener('blur', () => {
      const digits = normalizeTunisiaPhone(phone.value);
      phone.value = digits ? formatTunisiaPhone(digits) : formatPhoneInput(phone.value);
    });
  }

  function bindCheckout(root) {
    updateSummary(root);
    bindPhoneInput(root);
    bindFieldValidation(root);
  }

  function allRoots() {
    return document.querySelectorAll('[data-product-cod-checkout]');
  }

  // Quantity changes happen outside the COD block, so listen on the document.
  function onQuantityChange(event) {
    if (!(event.target instanceof Element) || !event.target.matches(QTY_SELECTOR)) return;
    allRoots().forEach(updateSummary);
  }

  document.addEventListener('change', onQuantityChange);
  document.addEventListener('input', onQuantityChange);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    // The theme's +/- buttons may set the value without firing an event.
    if (event.target.closest('[data-increment-quantity], [data-decrement-quantity]')) {
      setTimeout(() => allRoots().forEach(updateSummary), 0);
      return;
    }

    const addButton = event.target.closest('[data-cod-add-line]');
    if (addButton) {
      event.preventDefault();
      addCurrentLine(getRoot(addButton));
      return;
    }

    const removeButton = event.target.closest('[data-cod-remove-line]');
    if (removeButton) {
      event.preventDefault();
      removeLine(getRoot(removeButton), Number(removeButton.dataset.codRemoveLine));
      return;
    }

    const button = event.target.closest('[data-product-cod-submit]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    submitCodOrder(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    allRoots().forEach(bindCheckout);
  });

  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
    const root = input.closest('[data-product-cod-checkout]');
    if (!root || !input.value) return;

    const known = getVariants(root).get(String(input.value));
    if (known) {
      root.dataset.variantPrice = String(known.price);
      updateSummary(root);
      return;
    }

    try {
      const res = await fetch(`/variants/${input.value}.js`);
      const variant = await res.json();
      root.dataset.variantPrice = String(variant.price);
      updateSummary(root);
    } catch (e) {
      console.warn('product-cod variant', e);
    }
  });
})();
